<script setup lang="ts">
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';

interface MethodologyStep {
    type_name: string;
    type_description: string;
    filters_description?: string;
    result_count: number;
}

const props = defineProps<{
    methodology: MethodologyStep[];
}>();

const { t } = useI18n();

const isExpanded = ref(false);

const toggle = () => {
    isExpanded.value = !isExpanded.value;
};

const totalResults = computed(() =>
    props.methodology.reduce((sum, step) => sum + step.result_count, 0),
);
</script>

<template>
    <div v-if="methodology && methodology.length > 0" class="search-methodology">
        <button class="methodology-toggle" :class="{ expanded: isExpanded }" @click="toggle">
            <span class="toggle-icon">{{ isExpanded ? '▾' : '▸' }}</span>
            <span class="toggle-text">{{ t('chat.howISearched') }}</span>
            <span v-if="!isExpanded" class="toggle-summary">
                ({{ t('chat.methodologySources', methodology.length) }},
                {{ t('chat.methodologyResults', totalResults) }})
            </span>
        </button>

        <div v-if="isExpanded" class="methodology-content">
            <div v-for="(step, index) in methodology" :key="index" class="methodology-step">
                <span class="step-bullet">&bull;</span>
                <span class="step-description">
                    {{ t('chat.methodologySearched') }}
                    <strong>{{ step.type_description }}</strong>
                    <span
                        v-if="
                            step.filters_description &&
                            step.filters_description !== 'no filters applied'
                        "
                    >
                        {{ step.filters_description }}
                    </span>
                </span>
                <span class="step-count">
                    &rarr; {{ t('chat.methodologyFound', step.result_count) }}
                </span>
            </div>
        </div>
    </div>
</template>
